

import { 
	formatCurrency,
	formatSku,
} from '../utils/ddny';


export const DDNY_MODEL_SCHEMA = {
	'primary': {
		'title': 'Main',
		'fields': [
			{
				label: 'SKU',
				apiKey: 'sku',
				stateKey: 'inputSku',
				type: 'input',
				required: true,
				formatOnChange: formatSku,
				csvKey: 'Item SKU (Child)', 
			},
			{
				label: 'Future Parent',
				apiKey: 'future_parent',
				stateKey: '',
				type: '',
				required: false,
				csvKey: 'FUTURE PARENT', 
				hidden: true,
			},
			{
				label: 'Name',
				apiKey: 'name',
				stateKey: 'inputNameAlt',
				type: 'input',
				required: false,
				csvKey: '', 
			},
			{
				label: 'Enabled?',
				apiKey: 'is_enabled',
				stateKey: 'inputIsEnabled',
				type: 'toggle',
				required: false,
				toggleTrue: 'Enabled',
				toggleFalse: 'Disabled',
				csvKey: '', 
			},
			{
				label: '3D Video Link',
				apiKey: 'model_url',
				stateKey: 'inputModelUrl',
				type: 'input',
				required: false,
				limited: true,
				csvKey: null, 
				activateUrl: true,
			},
			{
				label: 'Store Cost',
				apiKey: 'cost',
				stateKey: null,
				type: 'input',
				required: false,
				limited: true,
				formatOnDisplay: formatCurrency,
				showCostOnly: true,
				variantDisplay: true,
				csvKey: 'STORES COST', 
			},
			{
				label: 'Metal Color',
				apiKey: 'gold_color',
				stateKey: null,
				type: 'input',
				required: false,
				limited: false,
				csvKey: 'Metal Color', 
				hidden: true,
			},
			{
				label: 'Karat Weight',
				apiKey: 'gold_weight',
				stateKey: null,
				type: 'input',
				required: false,
				limited: false,
				csvKey: 'Metal Karat Content', 
				hidden: true,
			},
			{
				label: 'Retail Price',
				apiKey: 'price',
				stateKey: null,
				type: 'variantModal',
				required: false,
				limited: false,
				formatOnDisplay: formatCurrency,
				showCostOnly: true,
				variantDisplay: true,
				useApiData: false,
				csvKey: 'RETAIL COST', 
			},
			{
				label: 'Breakdown',
				apiKey: 'breakdown',
				stateKey: 'inputBreakdown',
				type: 'textarea',
				required: false,
				limited: true,
				csvKey: 'BREAKDOWN', 
			},
			{
				label: 'Factory',
				apiKey: 'factory',
				stateKey: 'inputFactory',
				type: 'textarea',
				required: false,
				limited: true,
				csvKey: 'FACTORY', 
			},
			{
				label: 'Short Description',
				apiKey: 'description',
				stateKey: 'inputDescriptionShort',
				type: 'textarea',
				required: false,
				csvKey: 'Item Short Description', 
			},
			{
				label: 'Description',
				apiKey: 'description_short',
				stateKey: 'inputDescription',
				type: 'textarea',
				required: false,
				csvKey: 'Item Description', 
			},
		],
	},
	'vendor': {
		'title': 'Vendor',
		'fields': [
			{
				label: 'Vendor Style',
				apiKey: 'vendor_style',
				stateKey: 'inputVendorStyle',
				type: 'input',
				required: false,
				csvKey: 'Vendor Style', 
			},
			{
				label: 'Vendor Name',
				apiKey: 'vendor_name',
				stateKey: 'inputVendorName',
				type: 'input',
				required: false,
				csvKey: 'Vendor Name', 
			},
			{
				label: 'Vendor Number',
				apiKey: 'vendor_number',
				stateKey: 'inputVendorNumber',
				type: 'input',
				required: false,
				csvKey: 'Vendor #', 
			},
		],
	},
	'web': {
		'title': 'Web',
		'fields': [
			{
				label: 'Web Title',
				apiKey: 'web_title',
				stateKey: 'inputWebTitle',
				type: 'input',
				required: false,
				csvKey: 'Item Web Title', 
			},
			{
				label: 'Web Description',
				apiKey: 'web_description',
				stateKey: 'inputWebDescription',
				type: 'input',
				required: false,
				csvKey: 'Item Web Description', 
			},
		],
	},
	'center': {
		'title': 'Center Stone',
		'fields': [
			{
				label: 'Center Shape',
				apiKey: 'center_shape',
				stateKey: 'inputCenterShape',
				type: 'input',
				required: false,
				csvKey: 'Center Diamond & Gemstone Shape', 
			},
			{
				label: 'Gemstone Type',
				apiKey: 'center_gemstone_type',
				stateKey: 'inputCenterGemstoneType',
				type: 'input',
				required: false,
				csvKey: 'Center Gemstone Type', 
			},
			{
				label: 'Gemstone Color',
				apiKey: 'center_gemstone_color',
				stateKey: 'inputCenterGemstoneColor',
				type: 'input',
				required: false,
				csvKey: 'Center Gemstone Color', 
			},
			{
				label: 'Gemstone Weight',
				apiKey: 'center_gemstone_weight',
				stateKey: 'inputCenterGemstoneWeight',
				type: 'input',
				required: false,
				csvKey: 'Center Gemstone Weight', 
			},
			{
				label: 'Gemstone COO',
				apiKey: 'center_gemstone_coo',
				stateKey: 'inputCenterGemstoneCoo',
				type: 'input',
				required: false,
				csvKey: 'Center Gemstone COO', 
			},
		],
	},
	'noncenter': {
		'title': 'Non-Center Stone',
		'fields': [
			{
				label: 'Diamond Weight',
				apiKey: 'noncenter_diamond_weight',
				stateKey: 'inputNonCenterDiamondWeight',
				type: 'input',
				required: false,
				csvKey: 'Non-center Diamond Carat Weight', 
			},
			{
				label: 'Diamond Color',
				apiKey: 'noncenter_diamond_color',
				stateKey: 'inputNonCenterDiamondColor',
				type: 'input',
				required: false,
				csvKey: 'Non-center Diamond Color Grade', 
			},
			{
				label: 'Diamond Clarity',
				apiKey: 'noncenter_diamond_clarity',
				stateKey: 'inputNonCenterDiamondClarity',
				type: 'input',
				required: false,
				csvKey: 'Non-center Diamond Clarity Grade', 
			},
			{
				label: 'Shape 1',
				apiKey: 'noncenter_shape_1',
				stateKey: 'inputNonCenterShape1',
				type: 'input',
				required: false,
				csvKey: 'Non-center Stone Shape 1', 
			},
			{
				label: 'Shape 2',
				apiKey: 'noncenter_shape_2',
				stateKey: 'inputNonCenterShape2',
				type: 'input',
				required: false,
				csvKey: 'Non-center Stone Shape 2', 
			},
			{
				label: 'Stone Count',
				apiKey: 'noncenter_stone_count',
				stateKey: 'inputNonCenterStoneCount',
				type: 'input',
				required: false,
				csvKey: 'Non-Center # of stones', 
			},
			{
				label: 'Gemstone Type',
				apiKey: 'noncenter_gemstone_type',
				stateKey: 'inputNonCenterGemstoneType',
				type: 'input',
				required: false,
				csvKey: 'Non-Center Gemstone Type', 
			},
			{
				label: 'Gemstone Weight',
				apiKey: 'noncenter_gemstone_weight',
				stateKey: 'inputNonCenterGemstoneWeight',
				type: 'input',
				required: false,
				csvKey: 'Non-center Gemstone Total Weight', 
			},
		],
	},
}


export const CSV_TEMPLATE_SCHEMA = [
	'DIVISION',
	'DEPT',
	'CLASS',
	'FUTURE PARENT',
	'Item SKU (Child)',
	'DDNY ATTRIBUTES',
	'BREAKDOWN',
	'FACTORY',
	'Item Description',
	'Item Short Description',
	'Item Web Title',
	'Item Web Description',
	'Vendor Style',
	'Vendor Name',
	'Vendor #',
	'Metal Color',
	'Metal Karat Content',
	'STORES COST',
	'Center Gemstone Type',
	'Center Diamond & Gemstone Shape',
	'Center Gemstone Color',
	'Center Gemstone Weight',
	'Center Gemstone COO',
	'Non-center Diamond Carat Weight',
	'Non-center Diamond Color Grade',
	'Non-center Diamond Clarity Grade',
	'Non-center Stone Shape 1',
	'Non-center Stone Shape 2',
	'Non-Center # of stones',
	'Non-Center Gemstone Type',
	'Non-center Gemstone Total Weight',
	'Mounting Style',
	'Center Stone Setting',
	'Diamond Coverage',
	'Non-Center Stone Setting',
	'Mounting Features',
	'Bridal Band Features',
	'Fashion Band Features',
	'Clasp Type',
	'Bracelet Rows',
	'Earring Type',
	'Chain Type',
	'Necklace Type',
	'Jewelry Motif',
	'Pendant Length',
	'Pendant Length UOM',
	'Pendant Width',
	'Pendant Width UOM',
	'Ring Size',
	'Additional Band Material Type',
	'Metal Finish',
	'Item Length',
	'Item Length UOM',
	'Item Width',
	'Item Width UOM',
	'Item Diameter',
	'Item Diameter UOM',
	'Clasp Attachment Type',
	'Bail Type',
	'Earring Backs & Earring Posts',
];

export const CSV_TEMPLATE_VARIANT_SCHEMA = [
	'Metal Color',
	'Metal Karat Content',
	'STORES COST',
];